// components/admin/PendingRequests/styles.js

import styled from 'styled-components';

export const RequestsContainer = styled.div`
    padding: ${props => props.theme.spacing.xl};
    background: ${props => props.theme.colors.background.alt};
    min-height: 100%;
`;

export const RequestsHeader = styled.div`
    margin-bottom: ${props => props.theme.spacing.xl};

    h2 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.xs};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.md};
    }
`;

export const RequestsList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: ${props => props.theme.spacing.lg};

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
        grid-template-columns: 1fr;
    }
`;

export const RequestCard = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};
    overflow: hidden;
    transition: transform ${props => props.theme.transitions.normal};
    display: flex; 
    flex-direction: column;
    height: 100%; 

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${props => props.theme.shadows.md};
    }
`;


export const CardHeader = styled.div`
    padding: ${props => props.theme.spacing.lg};
    border-bottom: 1px solid ${props => props.theme.colors.border};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: ${props => props.theme.spacing.sm};
`;

export const UserDetails = styled.div`
    h3 {
        font-size: ${props => props.theme.typography.sizes.lg};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.xs};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.sm};
    }
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: ${props => `${props.theme.spacing.xs} ${props.theme.spacing.sm}`};
    border-radius: ${props => props.theme.borderRadius.full};
    font-size: ${props => props.theme.typography.sizes.sm};
    font-weight: ${props => props.theme.typography.weights.medium};
    
    ${props => {
        switch (props.status) {
            case 'pending_admin':
                return `
                    background: ${props.theme.colors.warning.main}15;
                    color: ${props.theme.colors.warning.main};
                `;
            case 'pending_payment':
                return `
                    background: ${props.theme.colors.primary.main}15;
                    color: ${props.theme.colors.primary.main};
                `;
            case 'payment_submitted':
                return `
                    background: ${props.theme.colors.warning.main}15;
                    color: ${props.theme.colors.warning.main};
                `;
            case 'active':
                return `
                    background: ${props.theme.colors.success.main}15;
                    color: ${props.theme.colors.success.main};
                `;
            case 'rejected':
                return `
                    background: ${props.theme.colors.error.main}15;
                    color: ${props.theme.colors.error.main};
                `;
            default:
                return `
                    background: ${props.theme.colors.text.disabled}15;
                    color: ${props.theme.colors.text.disabled};
                `;
        }
    }}
`;

export const CardBody = styled.div`
    padding: ${props => props.theme.spacing.lg};
`;

export const PlanDetails = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};
    padding-bottom: ${props => props.theme.spacing.lg};
    border-bottom: 1px solid ${props => props.theme.colors.border};

    h4 {
        font-size: ${props => props.theme.typography.sizes.lg};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.xs};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.md};
    }
`;

export const ChildInfo = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};
    padding: ${props => props.theme.spacing.md};
    background: ${props => props.theme.colors.background.alt};
    border-radius: ${props => props.theme.borderRadius.md};

    span {
        display: block;
        color: ${props => props.theme.colors.text.primary};

        &.discount {
            margin-top: ${props => props.theme.spacing.xs};
            color: ${props => props.theme.colors.success.main};
            font-size: ${props => props.theme.typography.sizes.sm};
        }
    }
`;

export const PriceInfo = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};
`;

export const InfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.sizes.md};

    &.discount {
        color: ${props => props.theme.colors.success.main};
    }

    &.total {
        margin-top: ${props => props.theme.spacing.md};
        padding-top: ${props => props.theme.spacing.md};
        border-top: 1px dashed ${props => props.theme.colors.border};
        font-weight: ${props => props.theme.typography.weights.bold};
    }
`;

export const CardFooter = styled.div`
    padding: ${props => props.theme.spacing.lg};
    border-top: 1px solid ${props => props.theme.colors.border};
    background: ${props => props.theme.colors.background.alt};
    margin-top: auto;
`;

export const ActionButtons = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing.md};

    button {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${props => props.theme.spacing.sm};
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: ${props => props.theme.spacing.xl};
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    
    svg {
        color: ${props => props.theme.colors.text.disabled};
        margin-bottom: ${props => props.theme.spacing.lg};
    }

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;